<div class="container-fluid" >
    <div class="lateral">
        <div class="option-button" >
            <button mat-button class="action first"
                *ngIf="!hidePreview"
                (click)="onPreviewClick()"
                title="Vista previa" 
                [disabled]="disabled">
                <mat-icon>remove_red_eye</mat-icon>
                <span>{{previewButtonLabel}}</span>
            </button>

            <button mat-button class="action"
                *ngIf="!hidePrint"
                (click)="onPrintClick()"
                title="Imprimir" 
                [disabled]="disabled">
                <mat-icon>print</mat-icon>
                <span>{{printButtonLabel}}</span>
            </button>

            <button mat-button class="action"
                *ngIf="!hidePdf"
                (click)="onPdfClick()"
                title="PDF" 
                [disabled]="disabled">
                <mat-icon>picture_as_pdf</mat-icon>
                <span>{{pdfButtonLabel}}</span>
            </button>

            <button mat-button class="action"
                *ngIf="!hideExcel"
                (click)="onExcelClick()"
                [title]="excelButtonLabel || 'Excel'" 
                [disabled]="disabled">
                <mat-icon>insert_drive_file</mat-icon>
                <span>{{excelButtonLabel}}</span>
            </button>

            <button mat-button class="action"
                *ngIf="!hideText"
                (click)="onTextClick()"
                [title]="textButtonLabel || 'TXT'"
                [disabled]="disabled">
                <mat-icon>text_snippet</mat-icon>
                <span>{{textButtonLabel}}</span>
            </button>

            <button mat-button class="action draft"
                *ngIf="canSaveDraft"
                (click)="onSaveDraft()"
                title="Descargar reporte como JSON"
                [disabled]="disabled">
                <mat-icon>download</mat-icon>
                <span>DESCARGAR DATOS</span>
            </button>

            <button mat-button class="action draft"
                *ngIf="canSaveDraft"
                (click)="onRestoreDraft()"
                title="Cargar reporte desde JSON">
                <mat-icon>upload</mat-icon>
                <span>CARGAR DATOS</span>
            </button>

            <input
                #fileInput
                type="file"
                accept=".json"
                (change)="onFileSelected($event)"
                style="display: none;" />
        </div>

        <div class="nav-button">
            <div class="title">Otros reportes</div>
            
            <div class="box">
                <ng-container *ngFor="let link of links">
                    <mat-list-item class="action"
                        *ngIf="testPerm(link)"
                        [matTooltip]="link.label"
                        title=""
                        routerLinkActive="is-active"
                        [routerLink]="'../../' + link.link">
                        <span>{{link.label}}</span>
                    </mat-list-item>
                </ng-container>
            </div>
        </div>
    </div>
    <div class="content">
        <div class="content-box">
            <div class="title">
                {{ title }}
            </div>
            <ng-content select="[slot=content]"></ng-content>
        </div>
    </div>
  </div>
  